var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkDoneSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#34B7F1",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 44,
    d: "M465 127L241 384l-92-92M140 385l-93-93M363 127L236 273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkDoneSharp);
export default __webpack_public_path__ + "static/media/checkmark-done-sharp.e92a7388a047f3c5a06ceac712c44d3a.svg";
export { ForwardRef as ReactComponent };